import { TUpdateUserDto } from "types/Core/Users/updateUserDto";

const editUserMapper = (formValues: any): TUpdateUserDto => ({
  username: formValues.username,
  name: formValues.name,
  lastname: formValues.lastname,
  mail: formValues.mail,
  state: Boolean(Number(formValues.state.value)),
});

export default editUserMapper;
